module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout')
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0337de3d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/scoped/post/VideoForm.vue
// module id = 1975
// module chunks = 0